import { OnInit, ChangeDetectorRef } from '@angular/core';
import { forkJoin } from 'rxjs';
import { UsersService } from '../../../shared/services/users.service';
import { NotificationsService } from '../../../shared/services/notification.service';
import { LocalisationService } from '../../../shared/services/localisation.service';
import { ProductsService } from '../../../shared/services/products.service';
import { MasterService } from '../../../shared/services/master.service';
import { AppLoadingEventsEmitter } from '../../../shared/events/loading.events';
var MasterBodySectionComponent = /** @class */ (function () {
    function MasterBodySectionComponent(usersService, notificationService, localisationService, changeDetectorRef, productsService, masterService, appIsLoadingEventsEmitter) {
        this.usersService = usersService;
        this.notificationService = notificationService;
        this.localisationService = localisationService;
        this.changeDetectorRef = changeDetectorRef;
        this.productsService = productsService;
        this.masterService = masterService;
        this.appIsLoadingEventsEmitter = appIsLoadingEventsEmitter;
        this.editable = true;
        this.notifications = true;
        this.loading = true;
        this.enabledByAllergy = {};
    }
    MasterBodySectionComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.appIsLoadingEventsEmitter.broadcastAppIsLoading(true);
        forkJoin(this.masterService.getUserProfile(this.id), this.usersService.getUserDailyMeals(), this.usersService.getUserDiets(), this.productsService.getAllergies()).subscribe(function (_a) {
            var userProfile = _a[0], dailyMeals = _a[1], diets = _a[2], allergies = _a[3];
            _this.dailyMeals = dailyMeals;
            _this.diets = diets;
            _this.allergies = allergies;
            _this.changeDetectorRef.detectChanges();
            _this.initCurrentUserProfile(userProfile);
            _this.appIsLoadingEventsEmitter.broadcastAppIsLoading(false);
        });
    };
    MasterBodySectionComponent.prototype.updateProfile = function () {
        var _this = this;
        this.appIsLoadingEventsEmitter.broadcastAppIsLoading(true);
        this.usersService
            .updateMasterUserProfile(this.id, {
            daily_meals: {
                id: this.currentlySelectedDailyMeal.id
            },
            diet: this.currentlySelectedDiet ? { id: this.currentlySelectedDiet.id } : null,
            allergies: Object.keys(this.enabledByAllergy).filter(function (k) { return _this.enabledByAllergy[k]; }).map(function (k) { return +k; }).map(function (id) {
                return { id: id };
            }),
        })
            .subscribe(function () {
            _this.appIsLoadingEventsEmitter.broadcastAppIsLoading(false);
            _this.changeDetectorRef.detectChanges();
            if (_this.notifications) {
                _this.notificationService.success(_this.localisationService.localise('settings_profile_updated_successfully'));
            }
        });
    };
    Object.defineProperty(MasterBodySectionComponent.prototype, "saveButtonIsDisabled", {
        get: function () {
            return !this.currentlySelectedDailyMeal;
        },
        enumerable: true,
        configurable: true
    });
    MasterBodySectionComponent.prototype.initCurrentUserProfile = function (userProfile) {
        this.currentlySelectedDailyMeal = userProfile.daily_meals ? this.dailyMeals.find(function (dm) { return dm.id === userProfile.daily_meals.id; }) : undefined;
        this.currentlySelectedDiet = userProfile.diet ? this.diets.find(function (d) { return d.id === userProfile.diet.id; }) : undefined;
        this.initEnabledByAllergy(userProfile);
        this.changeDetectorRef.markForCheck();
    };
    MasterBodySectionComponent.prototype.initEnabledByAllergy = function (userProfile) {
        var _this = this;
        this.allergies.forEach(function (a) { return _this.enabledByAllergy[a.id] = false; });
        userProfile.allergies.forEach(function (a) {
            _this.enabledByAllergy[a.id] = true;
        });
    };
    return MasterBodySectionComponent;
}());
export { MasterBodySectionComponent };
